import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { normalize, schema } from 'normalizr';
import {
  createResponsiveStateReducer,
  responsiveStoreEnhancer,
} from 'redux-responsive';
import Immutable from 'immutable';
import get from 'lodash/get';

import reducers, { initialStates } from '../reducers';
import loggerMiddleware from '../../../lib/middlewares/loggerMiddleware';
import registrantsDuck from '../redux/modules/registrantsDuck'; // eslint-disable-line

const possibleAnswerSchema = new schema.Entity('$$possible_answers');
const questionSchema = new schema.Entity('$$questions', {
  possible_answers: [possibleAnswerSchema],
});

export default (props, railsContext) => {
  const { $$programState, $$settingsState, $$dashboardState } = initialStates;

  const normalizedQuestions = normalize(get(props.program, 'questions') || [], [
    questionSchema,
  ]);

  const initialState = {
    railsContext,
    $$settingsStore: $$settingsState.merge({
      $$organization: Immutable.fromJS(props.organization),
      $$user: Immutable.fromJS(props.user),
    }),
    $$dashboardStore: $$dashboardState.merge({
      organizationId: props.organization_id,
      organizationName: props.organization_name,
      organizer: props.current_user,
    }),
    $$programStore: $$programState
      .mergeDeep({
        $$program: props.program || {},
        $$entities: normalizedQuestions.entities,
        admin: props.admin,
        currencyCode: props.currencyCode,
        duplicate: props.duplicate,
        $$stripeStandardAccounts: Immutable.fromJS(
          props.stripe_standard_accounts
        ),
        defaultStripeConnectType: props.default_stripe_connect_type,
        organizationStandardJwFeeType: props.organizationStandardJwFeeType,
      })
      .set('$$questionIds', Immutable.OrderedSet(normalizedQuestions.result)),
  };

  switch (props.store_name) {
    case '$$organizerRegistrants': {
      initialState[registrantsDuck.store] = registrantsDuck.initialState.merge({
        $$program: Immutable.fromJS(props.program),
        $$questions: Immutable.fromJS(props.questions),
        admin: props.admin,
        $$programs: Immutable.fromJS(props.programs),
      });
      break;
    }
    default:
  }

  const reducer = combineReducers({
    ...reducers,
    routing: routerReducer,
    browser: createResponsiveStateReducer({
      small: 600,
      medium: 992,
    }),
  });

  // Sync dispatched route actions to the history
  const finalCreateStore = compose(
    responsiveStoreEnhancer,
    applyMiddleware(thunkMiddleware, loggerMiddleware, promiseMiddleware)
  )(createStore);

  if (__DEV__) {
    // eslint-disable-line no-undef
    return finalCreateStore(
      reducer,
      initialState,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line
    );
  }

  return finalCreateStore(reducer, initialState);
};
